import $ from 'jquery';

window.wfnlcb = function(data) {
  var form = $('.newsletter_form');
  if (data.status == 'success') {
    $(form).text(data.message);
  } else {
    $(form).find('.form-errors').text(data.message);
  }
};

$(function() {
  function killEvent(evt) {
    evt.preventDefault();
    evt.stopPropagation();
    return false;
  }

  $('.newsletter_form').on('submit', function(evt) {
    var form = evt.currentTarget;
    var hp = $(form).find('[name=pardot_extra_field]');
    var data = {
      email: $(form).find('[name=email]').val(),
      pardot_extra_field: hp.val()
    };
    if (hp.val() != '') {
      return killEvent();
    }


    $.ajax({
      url: 'https://info.wakefly.com/l/5102/2019-12-10/6ddchx',
      method: 'POST',
      data: data,
      dataType: 'jsonp',
      jsonpCallback: 'wfnlcb'
    })

    return killEvent(evt);
  })
})